import { render, staticRenderFns } from "./AvaliacaoRascunho.vue?vue&type=template&id=5ec54354&scoped=true&"
import script from "./AvaliacaoRascunho.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoRascunho.vue?vue&type=script&lang=js&"
import style0 from "./AvaliacaoRascunho.vue?vue&type=style&index=0&id=5ec54354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec54354",
  null
  
)

export default component.exports